import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';
import Input from '../../../common/input';
import CurrencyInput from '../../../common/currencyInput';
import OptionInput from '../../../common/optionInput';

const TYPE_TRANSLATION_MAP = {
  payout: 'register:cash_register.payout_option',
  'pay-in': 'register:cash_register.payin_option',
};

const getTranslatedType = (type) => {
  if (!TYPE_TRANSLATION_MAP[type]) {
    return type;
  }
  return t(TYPE_TRANSLATION_MAP[type]);
};

const PayoutForm = ({ submitting, handleSubmit, save, pristine, valid, type }) => (
  <div className="u-ph+ u-pv">
    <form onSubmit={handleSubmit(save)}>
      <fieldset className="o-flexbox o-flexbox--column" disabled={submitting}>
        <div className="u-pv-">
          <OptionInput name="type" value="payout" size="s" className="u-mr">
            {t('register:cash_register.payout_option')}
          </OptionInput>
          <OptionInput name="type" value="pay-in" size="s">
            {t('register:cash_register.payin_option')}
          </OptionInput>
        </div>
        <div className="u-ph u-pv u-mt- u-bg-white u-border-radius-4">
          <Input
            className="c-input c-input--white u-mb-"
            name="desc"
            type="text"
            placeholder={t('register:cash_register.enter_description_placeholder')}
          />
          <CurrencyInput
            className="c-input c-input--white c-input-group__first u-flex-1"
            placeholder={t('register:cash_register.enter_price_placeholder')}
            type="number"
            pattern="[\d\.]*"
            step="0.01"
            name="amount"
            noValidate
          />
        </div>
        <button
          type="submit"
          className="c-btn c-btn--wide o-flexbox__item u-mt"
          name="chargeCB"
          disabled={pristine || !valid}
        >
          {t('register:cash_register.confirm_type', { type: getTranslatedType(type) })}
        </button>

      </fieldset>
    </form>
  </div>
);

PayoutForm.propTypes = {
  submitting: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  type: PropTypes.string,
};
PayoutForm.defaultProps = {};

export default PayoutForm;
